<script>
	// Stores
	import BetReviewPayoutStore from '@/Stores/BetReviewPayoutStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, removeUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	import Polling from '@/Components/Polling.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Partials
	import BetTickerRow from '@/Partials/Bets/_BetTickerRow.svelte';
	import ReviewPayout from '@/Partials/Bets/_ReviewPayout.svelte';
	import Helmet from '@/Components/Helmet.svelte';

	$: links = $BetReviewPayoutStore.count() && paginationBuilder(BetReviewPayoutStore.getPagination());

	let pageNo = getUrlParameter('page') || 1;
	let searchBetId = getUrlParameter('ticket_id') || '';
	let pageSize = 50;
	let searching = false;
	let loading = searchBetId ? onSearchClick() : getBets();

	function onSearchClick() {
		if (!parseInt(searchBetId)) return;
		setUrlParameter('ticket_id', searchBetId);
		searching = true;
		BetReviewPayoutStore.getBets({ size: pageSize, number: pageNo }, { id: searchBetId }).finally(
			() => (searching = false)
		);
	}

	function onClearSearchClick() {
		searchBetId = '';
		removeUrlParameter('ticket_id');
		getBets();
	}

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getBets();
			setUrlParameter('page', pageNo);
		}
	}

	function getBets() {
		return BetReviewPayoutStore.getBets({ size: pageSize, number: pageNo });
	}
</script>

<Helmet title="Bet review payout" />
<ReviewPayout store={$BetReviewPayoutStore} on:saved={getBets} />
<Polling pollFunction={getBets} frequency={60} />
<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center justify-between w-full">
					<h1 class="text-xl font-bold">Review Payout</h1>
					<div class="flex items-center space-x-2">
						<TextInput name="bet_ticket_id" bind:value={searchBetId} placeholder="Bet Ticket ID..." />
						<LoadingButton on:click={onSearchClick} className="btn btn-black" loading={searching}>Search</LoadingButton>
						<button on:click={onClearSearchClick} class="btn btn-muted"> Clear </button>
					</div>
				</div>
			</div>
			<!-- /Page Header -->
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<!-- <Pagination {links} on:click={changePage} className="mt-2" /> -->
				<div class="overflow-x-auto rounded">
					<table class="w-full">
						<thead>
							<tr class="text-xs text-left text-gray-500 uppercase">
								<th class="px-6 pt-5 pb-4 font-medium">Ticket</th>
								<th class="px-6 pt-5 pb-4 font-medium">Date</th>
								<th class="px-6 pt-5 pb-4 font-medium">User</th>
								<th class="px-6 pt-5 pb-4 font-medium">Event</th>
								<th class="px-6 pt-5 pb-4 font-medium">Result</th>
								<th class="px-6 pt-5 pb-4 font-medium">Bet</th>
								<th class="px-6 pt-5 pb-4 font-medium">Actual Win Limit</th>
								<th class="px-6 pt-5 pb-4 font-medium">Win Limit Rule</th>
								<th class="px-6 pt-5 pb-4 font-medium text-center">Status</th>
							</tr>
						</thead>
						<tbody class="bg-white">
							{#each $BetReviewPayoutStore.all() as bet (bet.id)}
								<tr class="hover:bg-gray-100 focus-within:bg-gray-100">
									<BetTickerRow {bet} betTicker={false} reviewPayout={true} />
								</tr>
							{:else}
								<tr>
									<td class="px-6 py-4 text-center border-t" colspan="9"> No bets found. </td>
								</tr>
							{/each}
						</tbody>
					</table>
				</div>
				<Pagination {links} on:click={changePage} className="my-3" />
			</div>
		</div>
	{/await}
</div>
